const isHeroVisible = (state = false, action) => {
  switch (action.type) {
      case 'SET_HERO_VISIBLE':
        console.log(action)
          return action.visible
      default:
          return state
  }
}

export default isHeroVisible;